import { RequestType, geocode, setKey } from "react-geocode";
import { LocationObj } from "services/redux/site/site";

export type LatLngObj = {
    lat: number;
    lng: number;
};

const { REACT_APP_GOOGLE_API_KEY } = process.env;
const getFormattedAddress = (
    latLng: LatLngObj,
    setLocation: (latLng: LocationObj) => void
) => {
    // Get address from latitude & longitude.

    setKey(REACT_APP_GOOGLE_API_KEY || "");
    geocode(RequestType.LATLNG, `${latLng.lat},${latLng.lng}`)
        .then(({ results }) => {
            const address = results[0].formatted_address;
            console.log("getFormattedAddress: ", results[0].formatted_address);
            // setLocation({})
            setLocation({ ...latLng, address });
        })
        .catch((Error) => {
            console.error(Error);
            setLocation({ ...latLng, address: "" });
        });
};

export default getFormattedAddress;
